import * as React from 'react'
import { Image, type Picture } from '#app/components/ui/image'
import { testId } from '#app/utils/client/test-id.ts'

enum TEST_ID {
	funk = 'funk',
}

type FunkProps = {
	link: string
	picture: Picture
}

const funks: FunkProps[] = [
	{
		link: '/en/blog/aed17d13-d71f-40cf-bcd0-a6c3ebcd23bc?page=6&more=%2Fen%2Fblog%3Fpage%3D6',
		picture: {
			img: {
				src: '/pwa/funk/antenne_logo.webp?w=300',
				alt: 'Antenne Niedersachsen',
				width: 80,
				height: 40,
			},
		},
	},
]

const Funk: React.FC = () => {
	return (
		<ul {...testId(TEST_ID.funk)}>
			{funks.map(({ link, picture }: FunkProps) => (
				<li key={link}>
					<a href={link}>
						<Image
							api={false}
							alt={picture.img.alt}
							src={picture.img.src}
							picture={picture}
							loading="lazy"
						/>
					</a>
				</li>
			))}
		</ul>
	)
}

/* -----------------------------------------------------------------------------------------------*/

export { Funk, TEST_ID as FUNK_TEST_ID }
